<section #matCardElement class="flex-100">
  <vdw-header svgIcon="add-blue" [title]="'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'DESIGN_LIBRARY.DESIGN' | bmsTranslate: {count: 1} | lowercase}" [canShowClose]="true"></vdw-header>
  <article class="dialog-content">
    <div [formGroup]="addJuteToPathForm" class="flex-column">
      <div class="flex-column" fxFlex="100">
        <div class="flex-row patterns-wrapper">
          <mat-form-field class="full-width">
            <mat-label>{{ 'TEXTILE_DATA.MACHINE_QUALITY.PATTERN_OR_DRAWING' | bmsTranslate: {count: 1} }}</mat-label>
            <vdw-object-selection
              formControlName="pattern"
              [objectName]="'TEXTILE_DATA.MACHINE_QUALITY.PATTERN_OR_DRAWING' | bmsTranslate: {count: 1} | lowercase"
              [conditionalChipValueKey]="PATTERN_CONDITIONAL_CHIP_VALUE_KEY"
              (selectClicked)="selectPattern('pattern')"
            ></vdw-object-selection>
            <mat-error *ngIf="canShowErrorForFormControl('required', 'pattern', addJuteToPathForm)">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
          </mat-form-field>
          <div *ngIf="hasChosenPatternOrPatternFields()">
            <app-pattern-example
              class="pattern-example"
              [weaveQualityType]="getQualityType()"
              [canShowColor]="false"
              [pattern]="getPattern('pattern')"
              [weaveStructureId]="getWeaveStructureId()"
            ></app-pattern-example>
          </div>
        </div>
      </div>
      <div class="flex-column">
        <div class="flex-row" fxLayoutGap="16px">
          <mat-form-field fxFlex>
            <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" step="1" formControlName="heightInPx" [decimals]="false" />
            <span matSuffix>{{ 'GENERAL.UNIT.PIXEL' | bmsTranslate }}</span>
            <mat-error *ngIf="canShowErrorForFormControl('required', 'heightInPx', addJuteToPathForm)">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
            <mat-error *ngIf="canShowErrorForFormControl('min', 'heightInPx', addJuteToPathForm)">
              {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: getMinPatternHeight()} }}
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
            <input matInput vdwL10nDecimal type="number" step="0.1" [maximumFractionDigits]="1" formControlName="heightInCm" [decimals]="true" />
            <span matSuffix>{{ 'GENERAL.UNIT.CENTIMETER' | bmsTranslate }}</span>
            <mat-error *ngIf="canShowErrorForFormControl('required', 'heightInCm', addJuteToPathForm)">
              {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
            </mat-error>
            <mat-error *ngIf="canShowErrorForFormControl('min', 'heightInCm', addJuteToPathForm)">
              {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: '0.1'} }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </article>

  <vdw-footer
    [locked]="canLockButton()"
    cancelEventName="GENERAL.ACTIONS.CANCEL"
    chooseEventName="GENERAL.ACTIONS.ADD"
    [centered]="true"
    (cancelEvent)="cancelEvent()"
    (chooseEvent)="applyChangesToProductionScheduleItemsInSchedule()"
  ></vdw-footer>
</section>
